import React from "react";
import Nav from "./Nav";
import "../css/ofertat.css";
import "../rensponsive/ofertat.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import Footer from "./Footer";

function Ofertat() {
  return (
    <div>
      <Nav />
      <section className="section-ofertat">
        <h1 className="photo-textt">Ofertat</h1>
        <span class="line line-oferta"></span>
        <h1 className="text-gender">Meshkuj</h1>

        <div class="containerr gridd grid--2-colss margin-button-mdd">
          <div class="pricing-plann pricing-plan--starterr">
            <header class="plan-headerr">
              <p class="plan-namee">12X Muaj</p>
              <p class="plan-pricee">
                <span>€</span>260
              </p>
              <div className="motivation-containerr">
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Ambient Motivues
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Trajner profesional
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Paisjet më moderne
                </p>
              </div>
              <p class="plan-textt"></p>
            </header>
          </div>
          <div class="pricing-plann pricing-plan--starterr">
            <header class="plan-headerr">
              <p class="plan-namee">6X Muaj</p>
              <p class="plan-pricee">
                <span>€</span>140
              </p>
              <div className="motivation-containerr">
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Ambient Motivues
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Trajner profesional
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Paisjet më moderne
                </p>
              </div>
              <p class="plan-textt"></p>
            </header>
          </div>
          <div class="pricing-plann pricing-plan--starterr">
            <header class="plan-headerr">
              <p class="plan-namee">3X Muaj</p>
              <p class="plan-pricee">
                <span>€</span>75
              </p>

              <div className="motivation-containerr">
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Ambient Motivues
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Trajner profesional
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Paisjet më moderne
                </p>
              </div>
              <p class="plan-textt"></p>
            </header>
          </div>
          <div class="pricing-plann pricing-plan--starterr">
            <header class="plan-headerr">
              <p class="plan-namee">1X Muaj</p>
              <p class="plan-pricee">
                <span>€</span>30
              </p>
              <div className="motivation-containerr">
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Ambient Motivues
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Trajner profesional
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Paisjet më moderne
                </p>
              </div>
              <p class="plan-textt"></p>
            </header>
          </div>
          <div class="pricing-plann pricing-plan--starterr">
            <header class="plan-headerr">
              <p class="plan-namee">1X Ditë</p>
              <p class="plan-pricee">
                <span>€</span>5
              </p>
              <div className="motivation-containerr">
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Ambient Motivues
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Trajner profesional
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Paisjet më moderne
                </p>
              </div>
              <p class="plan-textt"></p>
            </header>
          </div>
        </div>
      </section>
      <section className="section-ofertat">
        <h1 className="text-gender femer">Femra</h1>
        <div class="containerr gridd grid--2-colss grid-final">
          <div class="pricing-plann pricing-plan--completee">
            <header class="plan-headerr">
              <p class="plan-namee">12x Muaj</p>
              <p class="plan-pricee">
                <span>€</span>220
              </p>
              <div className="motivation-containerr">
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Ambient Motivues
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Trajner profesional
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Paisjet më moderne
                </p>
              </div>
              <p class="plan-textt"></p>
            </header>
          </div>
          <div class="pricing-plann pricing-plan--completee">
            <header class="plan-headerr">
              <p class="plan-namee">6x Muaj</p>
              <p class="plan-pricee">
                <span>€</span>120
              </p>
              <div className="motivation-containerr">
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Ambient Motivues
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Trajner profesional
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Paisjet më moderne
                </p>
              </div>
              <p class="plan-textt"></p>
            </header>
          </div>
          <div class="pricing-plann pricing-plan--completee">
            <header class="plan-headerr">
              <p class="plan-namee">3x Muaj</p>
              <p class="plan-pricee">
                <span>€</span>65
              </p>
              <div className="motivation-containerr">
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Ambient Motivues
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Trajner profesional
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Paisjet më moderne
                </p>
              </div>
              <p class="plan-textt"></p>
            </header>
          </div>
          <div class="pricing-plann pricing-plan--completee">
            <header class="plan-headerr">
              <p class="plan-namee">1x Muaj</p>
              <p class="plan-pricee">
                <span>€</span>25
              </p>
              <div className="motivation-containerr">
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Ambient Motivues
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Trajner profesional
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Paisjet më moderne
                </p>
              </div>
              <p class="plan-textt"></p>
            </header>
          </div>
          <div class="pricing-plann pricing-plan--completee-max">
            <header class="plan-headerr">
              <p class="plan-namee-max">12x Muaj për qift</p>
              <p class="plan-pricee">
                <span>€</span>360
              </p>
              <div className="motivation-containerr">
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Ambient Motivues
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Trajner profesional
                </p>
                <p class="motivation-text">
                  {" "}
                  <CheckCircleIcon
                    sx={{
                      marginRight: "8px",
                      color: "white",
                      width: 25,
                      height: 25,
                      backgroundColor: "transparent",
                    }}
                  />
                  Paisjet më moderne
                </p>
              </div>
              <p class="plan-textt"></p>
            </header>
          </div>
        </div>
      </section>
      <hr className="hr"></hr>
      <Footer />
    </div>
  );
}

export default Ofertat;
